import { useEffect, useState } from "react";

import { extractExtensionFromFilename, shortenFilename } from "@tsp-features/strings/utils";

import { AttachmentType } from "./attachment-field.enums";
import { AttachmentValue } from "./attachment-field.types";

interface Meta {
  link?: string;
  title?: string;
  preview?: string;
  extension?: string;
}

export const useAttachmentMeta = (value: AttachmentValue) => {
  const [result, setResult] = useState<Meta>({});

  useEffect(() => {
    const meta: Meta = {};

    switch (value.type) {
      case AttachmentType.File: {
        const extension = extractExtensionFromFilename(value.file.name);
        const isImage = ["png", "jpg", "jpeg", "webp"].includes(extension);

        meta.extension = isImage ? undefined : extension;
        meta.title = isImage ? undefined : shortenFilename(value.file.name, 24);
        meta.preview = isImage ? URL.createObjectURL(value.file) : undefined;
        break;
      }
      case AttachmentType.Link: {
        meta.extension = "TW";
        meta.link = value.link;
        meta.title = shortenFilename(value.link, 24);
        break;
      }
      case AttachmentType.FileDescriptor: {
        meta.title = shortenFilename(value.fileName, 24);
        meta.extension = extractExtensionFromFilename(value.fileName);
      }
    }

    setResult(meta);

    return () => {
      meta.preview && URL.revokeObjectURL(meta.preview);
    };
  }, [value]);

  return result;
};
